module.exports = __webpack_public_path__ + "static/media/ms.65000afe.jpg";